import React from "react";
import { Box, Typography, Grid, Card, CardContent, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import EventNoteIcon from "@mui/icons-material/EventNote";
import DirectionsBusFilledIcon from "@mui/icons-material/DirectionsBusFilled";

function TestDashboard() {
  const navigate = useNavigate();

  const handleNavigateToAttendance = () => {
    navigate("/hr/attendance");
  };

  const handleNavigateToTrips = () => {
    navigate("/trips");
  };

  return (
    <Box sx={{
      p: 3,
      bgcolor: "#f5f5f5",
      minHeight: "100vh",
    }}>
      <Box sx={{ mb: 4 }}>
        <Typography
          variant="h4"
          sx={{
            fontWeight: 700,
            color: "#1a1a1a",
            mb: 1
          }}
        >
          Welcome to Road Pilot Test Dashboard
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: "#666",
            fontSize: "16px"
          }}
        >
          Access your attendance and trips information here
        </Typography>
      </Box>

      <Grid container spacing={3}>
        {/* Attendance Card */}
        <Grid item xs={12} md={6}>
          <Card
            sx={{
              height: "100%",
              borderRadius: 2,
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
              "&:hover": {
                transform: "translateY(-4px)",
                boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
              },
            }}
          >
            <CardContent sx={{ p: 4, textAlign: "center" }}>
              <Box
                sx={{
                  width: 80,
                  height: 80,
                  borderRadius: "50%",
                  bgcolor: "#e3f2fd",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mx: "auto",
                  mb: 3
                }}
              >
                <EventNoteIcon sx={{ fontSize: 40, color: "#1976d2" }} />
              </Box>
              <Typography
                variant="h5"
                sx={{
                  fontWeight: 600,
                  color: "#1a1a1a",
                  mb: 2
                }}
              >
                Attendance
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  color: "#666",
                  mb: 3
                }}
              >
                View and manage your attendance records
              </Typography>
              <Button
                variant="contained"
                fullWidth
                onClick={handleNavigateToAttendance}
                sx={{
                  bgcolor: "#1976d2",
                  "&:hover": { bgcolor: "#1565c0" },
                  textTransform: "none",
                  py: 1.5,
                  fontWeight: 600,
                  fontSize: "16px"
                }}
              >
                Go to Attendance
              </Button>
            </CardContent>
          </Card>
        </Grid>

        {/* Trips Card */}
        <Grid item xs={12} md={6}>
          <Card
            sx={{
              height: "100%",
              borderRadius: 2,
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
              "&:hover": {
                transform: "translateY(-4px)",
                boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
              },
            }}
          >
            <CardContent sx={{ p: 4, textAlign: "center" }}>
              <Box
                sx={{
                  width: 80,
                  height: 80,
                  borderRadius: "50%",
                  bgcolor: "#fff3e0",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mx: "auto",
                  mb: 3
                }}
              >
                <DirectionsBusFilledIcon sx={{ fontSize: 40, color: "#f57c00" }} />
              </Box>
              <Typography
                variant="h5"
                sx={{
                  fontWeight: 600,
                  color: "#1a1a1a",
                  mb: 2
                }}
              >
                Trips
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  color: "#666",
                  mb: 3
                }}
              >
                View and manage your trip information
              </Typography>
              <Button
                variant="contained"
                fullWidth
                onClick={handleNavigateToTrips}
                sx={{
                  bgcolor: "#f57c00",
                  "&:hover": { bgcolor: "#ef6c00" },
                  textTransform: "none",
                  py: 1.5,
                  fontWeight: 600,
                  fontSize: "16px"
                }}
              >
                Go to Trips
              </Button>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <Box sx={{ mt: 4, p: 3, bgcolor: "#fff", borderRadius: 2, boxShadow: 1 }}>
        <Typography variant="body2" sx={{ color: "#666", textAlign: "center" }}>
          <strong>Note:</strong> This is a limited dashboard with access to Attendance and Trips only.
          For full access, please contact your administrator.
        </Typography>
      </Box>
    </Box>
  );
}

export default TestDashboard;